<script>
    import { onMount } from 'svelte'
    import logic from './logic.js'
    import shuffle from './shuffle.js'
    import palette from './palette'
    import random from './random'

    let counter = 0
    let shape = []
    let shapeRot = {}
    const pattern = shuffle(
        'p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14,p15'.split(',')
    )
        .slice(random(2, 8))
        .reduce((acc, p) => ({ ...acc, [p]: true }), {})

    let colors = palette(random(0, 100), random(0, 100), 100)

    $: result = logic({
        pattern,
        noiseRatioX: random(1, 1000),
        noiseRatioY: random(2000, 6000),
        noiseFormRatioX: random(1, 1000),
        noiseFormRatioY: random(2000, 6000),
        seed: Date.now(),
        colors,
    })
    function handleMousemove(event) {
        const center = event.currentTarget.scrollWidth / 2
        colors = palette(event.clientX, event.clientY, center)
    }

    onMount(() => {
        let frame
        const start = Date.now()
        function loop() {
            const c = Math.min(1, Math.floor((Date.now() - start) / 1000))
            frame = requestAnimationFrame(loop)
            counter = (counter + c) % 90
            shape.forEach((s) => (shapeRot[s] = shapeRot[s] + c))
            if (counter === 0) {
                shape = Array.from({ length: 5 }, () =>
                    Math.floor(Math.random() * 100)
                )
                shape.forEach((s) => {
                    if (!shapeRot[s]) {
                        shapeRot[s] = 0
                    }
                })
            }
        }
        loop()
        return () => cancelAnimationFrame(frame)
    })
</script>

<svg viewBox="0 0 900 900" id="svg" on:mousedown={handleMousemove}>
    <rect width="900" height="900" fill="white" />
    <g transform="translate(50,50)">
        {#each result as item, i}
            <g id={`layer-${i}`}>
                {#each item as { background, bgcolor, d, color, _x, _y }, j}
                    <path
                        d={background}
                        fill={bgcolor}
                        transform={shapeRot[j]
                            ? `rotate(${shapeRot[j]}, ${_x}, ${_y} )`
                            : ''}
                    />
                    {#each d as path}
                        <path
                            d={path}
                            fill={color}
                            transform={shapeRot[j]
                                ? `rotate(${shapeRot[j]}, ${_x}, ${_y} )`
                                : ''}
                        />
                    {/each}
                {/each}
            </g>
        {/each}
    </g>
</svg>
